import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagInventarioFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagInventario'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagInventario' label='Uso de inventario' />}
    </Field>
  )
}

export default React.memo(FlagInventarioFormGroup)
